export enum FeatureToggle {
  ProductsViewPage = 'rt_products_view_page',
  ProductViewPageShowLegacyEdit = 'rt_product_view_page_show_legacy_edit',
  ProductsViewPageShowRetailerLabelsOnlyOnStoreFrontPro = 'rt_products_view_page_only_show_retailer_label_ma_values',
  ProductSearchCPTButton = 'rt_catalog_product_search_report_cpt_problem',
  RetailerCollectionsV2 = 'rt_retailer_collections_ux_v2',
  SproutsTempOverrideEnabled = 'rt_catalog_sprouts_improved_product_search',
  InternalAdminTempOverrideEnabled = 'rt_catalog_internal_admin_temp_override_enabled',
  ForcemarksMissingCodes = 'rt_forcemarks_missing_codes',
  ProductsViewLowPriceAlerts = 'rt_products_view_low_price_alerts',
}
